import { GetTeamResponse } from "../../../api/types";
import { TeamCover } from "../../../components/S3Image";

interface TeamsGridProps {
  teams: GetTeamResponse[];
  onClickTeam: (teamId: string) => void;
}

export default function TeamsGrid({ teams, onClickTeam }: TeamsGridProps) {
  return (
    <ul className="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 xl:grid-cols-4">
      {teams.map((team) => (
        <li key={team._id} onClick={() => onClickTeam(team._id)}>
          <TeamCover
            keyPath={team.logo_key}
            alt={`${team.name} team cover`}
            className="w-full rounded-2xl cursor-pointer transition-all duration-300 hover:scale-105"
            // @ts-ignore
            style={{
              aspectRatio: "3/2",
            }}
          />
          <h3 className="mt-6 text-lg/8 font-semibold tracking-tight text-gray-900">
            {team.name}
          </h3>
          <p className="mt-1 text-sm text-gray-600">{team.pool}</p>
          <ul className="mt-6 flex">
            <a
              // @TODO: Support website url on the team level
              href={team?.metadata?.website_url}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-x-2 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Site web</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                />
              </svg>
              <span>Site Web</span>
            </a>
          </ul>
        </li>
      ))}
    </ul>
  );
}
